import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs/operators";
import { ApiService } from "../../../services/api.service";

@Component({
  selector: 'app-send-email-modal',
  templateUrl: './send-email-modal.component.html',
})
export class SendEmailModalComponent implements OnInit {
  email: string;
  brokerEmail: string;
  resMessage: string;
  isSending: boolean;
  isSuccess: boolean;

  @Input() modalData: any;
  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.email = this.modalData.email_data.join(', ');
    this.brokerEmail = this.modalData.cc_email_data.join(', ');
  }

  sendMail() {
    this.isSending = true;

    const data = {
      id: this.modalData.id,
      customer_broker_batch_zip_id: this.modalData.customer_broker_batch_zip_id,
      email: this.email,
      broker_email: this.brokerEmail,
      action_log_address: 'EMAIL_DASHBOARD',
    };

    this.apiService.resend_via_email_dashboard(data)
      .pipe(
        finalize(() => {
          this.isSending = false;
        })
      )
      .subscribe(
        (res: any) => {
          this.resMessage = res.message;
          this.isSuccess = true;
        },
        (err: any) => {
          this.resMessage = err.error;
          this.isSuccess = false;
        }
      );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'EMAIL_DASHBOARD',
      target: target
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/sendEmailModal/send-email-modal.component.ts